import { useState } from "react";
import { RegisteredAccount } from "@/features/accounts/account-group/services/add-account-groups-model";


export const useAddAccountGroupsStates = () => {
  const [accountGroupName, setAccountGroupName] = useState("");
  const [isActivateCreateButton, setIsActivateCreateButton] = useState(false);
  const [registeredAccounts, setRegisteredAccounts] = useState<RegisteredAccount[]>([]);
  const [check, setCheck] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    accountGroupName,
    setAccountGroupName,
    isActivateCreateButton,
    setIsActivateCreateButton,
    registeredAccounts,
    setRegisteredAccounts,
    check,
    setCheck,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
